module.exports = __webpack_public_path__ + "static/media/ic_ebooks.af158230.svg";